/* Runde 300 (UI/UX-Paket): Editor-Icons im Stil des Studio-Icon-Systems — 24×24-Raster, handgezeichnete Pfade, runde Strichenden, Strich 1,7 in
   currentColor (Light dunkel, Dark hell über die Textfarbe). Ersetzt den Lucide-Bestand des Übergabepakets v3; die Namen bleiben, damit ic() und alle
   Aufrufstellen unverändert weiterlaufen. Motive des Studio-Systems (shared/studioicons.ts) werden wiederverwendet, der Rest ist in derselben Sprache ergänzt. */

const P = (d: string) => `<path d="${d}"/>`;
const ARROW_U = P('M12 20V4M5 11l7-7 7 7'), ARROW_D = P('M12 4v16M5 13l7 7 7-7');
export const EDICONS: Record<string, string> = {
  mousePointer: P('M5 3l15 7.5-6.5 1.8L11.7 19z'),
  type2: P('M5 6V4h14v2M12 4v16M9 20h6'),
  paintbrush: P('M19 3l2 2-9 9-2-2zM10 12c-2 0-4 2-4 4s-2 3-3 3c3 1 7 0 8-3 .5-1 .3-2.6-1-4z'),
  penLine: P('M4 20h16M4 16l10-10 4 4-10 10H4zM12 8l4 4'),
  wandSparkles: P('M4 20l10-10M14 10l2 2M17 3v4M15 5h4M20 11v2M19 12h2M8 2v2M7 3h2'),
  moreH: '<circle cx="5" cy="12" r="1.2"/><circle cx="12" cy="12" r="1.2"/><circle cx="19" cy="12" r="1.2"/>',
  dotsLine: P('M4 12h16') + '<circle cx="8" cy="12" r="1.4"/><circle cx="16" cy="12" r="1.4"/>',
  neonGlow: P('M4 16c3-7 13-7 16 0M12 4v3M5.5 7.5l2 2M18.5 7.5l-2 2'),
  arrowU2: ARROW_U, arrowD2: ARROW_D,
  bleed3: P('M4 4h16v16H4zM4 9h16M9 4v16M4 15h16'),
  bleedAll: P('M7 7h10v10H7zM4 4h16v16H4z'),
  columns2: P('M4 4h16v16H4zM12 4v16'),
  printer: P('M6 9V3h12v6M6 17H3v-7h18v7h-3M6 14h12v7H6z'),
  cloudCheck: P('M7 18a4 4 0 0 1-.5-8A6 6 0 0 1 18 9a4 4 0 0 1 0 9H7zM9 14l2 2 4-4'),
  cloudOff: P('M7 18a4 4 0 0 1-.5-8A6 6 0 0 1 16 8M18 10a4 4 0 0 1 1 7.9M4 4l16 16'),
  undo2: P('M4 10h11a5 5 0 0 1 0 10h-3M4 10l4-4M4 10l4 4'),
  redo2: P('M20 10H9a5 5 0 0 0 0 10h3M20 10l-4-4M20 10l-4 4'),
  crop: P('M6 2v14a2 2 0 0 0 2 2h14M2 6h14a2 2 0 0 1 2 2v14'),
  replace: P('M4 7h10M4 7l3-3M4 7l3 3M20 17H10M20 17l-3-3M20 17l-3 3'),
  group: P('M3 3h8v8H3zM13 13h8v8h-8zM13 7h3a2 2 0 0 1 2 2v2M11 17H8a2 2 0 0 1-2-2v-2'),
  ungroup: P('M3 3h8v8H3zM13 13h8v8h-8zM15 5l4 4M19 5l-4 4'),
  bringFront: P('M8 8h12v12H8zM4 16V4h12'),
  sendBack: P('M4 4h12v12H4zM8 20h12V8'),
  bold: P('M7 4h6a4 4 0 0 1 0 8H7zM7 12h7a4 4 0 0 1 0 8H7zM7 4v16'),
  italic: P('M10 4h8M6 20h8M14 4l-4 16'),
  underline: P('M6 4v7a6 6 0 0 0 12 0V4M4 20h16'),
  strike: P('M4 12h16M16 6a4 4 0 0 0-4-2H11a3 3 0 0 0 0 6M8 18a4 4 0 0 0 4 2h1a3 3 0 0 0 3-3'),
  alignJ: P('M4 6h16M4 10h16M4 14h16M4 18h16'),
  layoutTpl: P('M3 3h18v18H3zM3 9h18M9 9v12'),
  grip: '<circle cx="9" cy="6" r="1.2"/><circle cx="15" cy="6" r="1.2"/><circle cx="9" cy="12" r="1.2"/><circle cx="15" cy="12" r="1.2"/><circle cx="9" cy="18" r="1.2"/><circle cx="15" cy="18" r="1.2"/>',
  droplet: P('M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11z'),
  contrast: '<circle cx="12" cy="12" r="9"/>' + P('M12 3v18a9 9 0 0 0 0-18z'),
  flipH: P('M12 3v18M8 7l-5 5 5 5M16 7l5 5-5 5'),
  flipV: P('M3 12h18M7 8l5-5 5 5M7 16l5 5 5-5'),
  rotateCw: P('M20 11a8 8 0 1 0-2.4 7.3M20 4v7h-7'),
  rotateCcw: P('M4 11a8 8 0 1 1 2.4 7.3M4 4v7h7'),
  unlink: P('M13 9l-4 4M8 15l-2 2a4 4 0 0 1-6-6l5-5M16 9l2-2a4 4 0 0 1 6 6l-5 5M3 3l18 18'),
  maximize: P('M4 9V4h5M15 4h5v5M20 15v5h-5M9 20H4v-5'),
  scanLine: P('M4 8V5a1 1 0 0 1 1-1h3M16 4h3a1 1 0 0 1 1 1v3M20 16v3a1 1 0 0 1-1 1h-3M8 20H5a1 1 0 0 1-1-1v-3M4 12h16'),
  paperclip: P('M20 11l-8.5 8.5a5 5 0 0 1-7-7L13 4a3.5 3.5 0 0 1 5 5l-8.5 8.5a2 2 0 0 1-3-3L15 6'),
  history: P('M4 12a8 8 0 1 0 2.4-5.7M4 4v5h5M12 8v4l3 2'),
  layoutTemplate: P('M3 3h18v6H3zM3 13h8v8H3zM15 13h6v8h-6z'),
  archiveRestore: P('M3 4h18v4H3zM5 8v12h14V8M12 18v-7M9 14l3-3 3 3'),
  frame: P('M6 3v18M18 3v18M3 6h18M3 18h18'),
  square: P('M4 4h16v16H4z'), circle: '<circle cx="12" cy="12" r="9"/>',
  folder2: P('M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM3 11h18'),
  tag: P('M3 3h9l9 9-9 9-9-9z') + '<circle cx="8" cy="8" r="1.2"/>',
  checkList: P('M3 6l2 2 3-3M3 13l2 2 3-3M3 20l2 2 3-3M12 6h9M12 13h9M12 20h9'),
  mask: P('M4 4h16v16H4z') + '<circle cx="12" cy="12" r="5"/>',
  letterSp: P('M3 20h18M6 4h8M10 4v12M14 10l3 3 3-3M17 6v7'),
  lineSp: P('M12 4h9M12 10h9M12 16h9M5 4v16M3 6l2-2 2 2M3 18l2 2 2-2'),
  compare: P('M12 3v18M3 7h6v10H3zM15 7h6v10h-6z'),
  conflict: P('M12 3l10 18H2zM12 10v4M12 17.5h.01'),
  pin: P('M12 17v5M8 17h8l-1-6 2-2V5H7v4l2 2z'),
  focus: '<circle cx="12" cy="12" r="3"/>' + P('M4 8V4h4M16 4h4v4M20 16v4h-4M8 20H4v-4'),
  keyboard: P('M3 6h18v12H3zM7 10h.01M11 10h.01M15 10h.01M7 14h10'),
  temperature: P('M10 4a2 2 0 0 1 4 0v9a4 4 0 1 1-4 0z'),
  healing: P('M9 3l12 12-6 6L3 9zM13 7l-6 6'),
  stamp: P('M5 21h14M6 17h12v-3a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2zM9 12l1-7h4l1 7'),
  pipette: P('M14 4l6 6M12 6l6 6-8 8H5v-5zM16 8l-9 9'),
  lasso: '<ellipse cx="12" cy="9" rx="8" ry="5"/>' + P('M7 13.5c-1 2-.5 4 1 5.5M8 19v2'),
  eraser2: P('M7 21h13M9 20l-5-5a2 2 0 0 1 0-3l8-8a2 2 0 0 1 3 0l5 5a2 2 0 0 1 0 3l-7 7M12 6l6 6'),
  sparkles: P('M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8zM5 19l.7 1.3L7 21l-1.3.7L5 23l-.7-1.3L3 21l1.3-.7zM19 3l.6 1.4L21 5l-1.4.6L19 7l-.6-1.4L17 5l1.4-.6z'),
  panelClose: P('M4 4h16v16H4zM15 4v16M8 10l-2 2 2 2'), panelOpen: P('M4 4h16v16H4zM15 4v16M8 10l2 2-2 2'),
  imagePlus: P('M14 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-9M19 2v6M16 5h6M3 17l5-5 4 4 3-3 3 3') + '<circle cx="9" cy="9" r="1.5"/>',
  move: P('M12 3v18M3 12h18M8 7l4-4 4 4M8 17l4 4 4-4M7 8l-4 4 4 4M17 8l4 4-4 4'),
  alertCircle: '<circle cx="12" cy="12" r="9"/>' + P('M12 8v5M12 16.5h.01'),
  safeArea: P('M3 3h18v18H3zM7 7h10v10H7z'),
  ruler: P('M3 17L17 3l4 4L7 21zM8 12l2 2M11 9l2 2M14 6l2 2'),
  textOverflow: P('M4 6h16M4 10h12M4 14h16M4 18h8M20 14l2 3-2 3'),
  textWrap: P('M4 6h16M4 12h13a3 3 0 0 1 0 6h-3M4 18h5M16 15l-2 3 2 3'),
  replaceText: P('M4 6h9M4 10h6M4 14h9M4 18h6M15 10l3-3 3 3M18 7v10M21 14l-3 3-3-3'),
  spellCheck: P('M4 16l4-10 4 10M5.5 12h5M13 8h6M13 12h4M14 18l2 2 5-5'),
  alHC: P('M12 3v18M6 8h12v8H6z'), alVC: P('M3 12h18M8 6h8v12H8z'),
  alHS: P('M4 3v18M8 7h10v4H8zM8 13h7v4H8z'), alHE: P('M20 3v18M6 7h10v4H6zM9 13h7v4H9z'),
  alVS: P('M3 4h18M7 8h4v10H7zM13 8h4v7h-4z'), alVE: P('M3 20h18M7 6h4v10H7zM13 9h4v7h-4z'),
  distH: P('M3 4v16M21 4v16M9 8h6v8H9z'), distV: P('M4 3h16M4 21h16M8 9h8v6H8z'),
  alignL2: P('M4 6h16M4 10h10M4 14h16M4 18h10'), alignC2: P('M4 6h16M7 10h10M4 14h16M7 18h10'), alignR2: P('M4 6h16M10 10h10M4 14h16M10 18h10'),
  play: P('M6 4l14 8-14 8z'), stop: P('M5 5h14v14H5z'),
  pinRegion: P('M4 4h16v16H4zM12 8v8M8 12h8'),
  micOff: P('M9 9v3a3 3 0 0 0 5 2M15 10V6a3 3 0 0 0-6 0M5 12a7 7 0 0 0 11 5.7M19 12a7 7 0 0 1-1 3.5M12 19v3M3 3l18 18'),
  textCurve: P('M4 15c3-6 13-6 16 0M9 19l3-7 3 7M10 17h4'),
  paragraph: P('M13 4v16M17 4v16M20 4H10a4 4 0 0 0 0 8h3'),
  pageNumber: P('M6 3h9l4 4v14H6zM15 3v4h4M9 17v-6l-2 1M13 11h3l-3 6h3'),
  expandImage: P('M14 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-9M21 3h-6M21 3v6M21 3l-7 7') + '<circle cx="9" cy="9" r="1.5"/>',
  brushSize: '<circle cx="7" cy="16" r="3"/><circle cx="16" cy="9" r="5"/>',
  maskInvert: '<circle cx="12" cy="12" r="9"/>' + P('M12 3a9 9 0 0 0 0 18zM12 7v10M9 9l6 6'),
  cornerRadius: P('M4 20V10a6 6 0 0 1 6-6h10'),
  bookSettings: P('M4 4h11a2 2 0 0 1 2 2v6M4 4v16h8M4 8h13') + '<circle cx="18" cy="18" r="3"/>' + P('M18 13v2M18 21v2M13 18h2M21 18h2'),
  layers2: P('M12 3l9 5-9 5-9-5zM3 13l9 5 9-5M3 17l9 5 9-5'),
  eye2: P('M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z') + '<circle cx="12" cy="12" r="3"/>',
  eyeOff2: P('M3 3l18 18M10 10a3 3 0 0 0 4 4M7 7C4 9 2 12 2 12s4 7 10 7c2 0 3.5-.5 5-1.3M12 5c6 0 10 7 10 7s-1 1.8-3 3.5'),
  lock2: P('M5 11h14v10H5zM8 11V7a4 4 0 0 1 8 0v4'), unlock2: P('M5 11h14v10H5zM8 11V7a4 4 0 0 1 7.5-1.8'),
  sliders2: P('M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12M20 18h0') + '<circle cx="16" cy="6" r="2"/><circle cx="10" cy="12" r="2"/><circle cx="18" cy="18" r="2"/>',
  minus2: P('M4 12h16'),
  hand2: P('M8 13V6a1.5 1.5 0 0 1 3 0v6M11 11V4a1.5 1.5 0 0 1 3 0v8M14 12V6a1.5 1.5 0 0 1 3 0v8M17 14a1.5 1.5 0 0 1 3 1v2a6 6 0 0 1-6 6h-2a6 6 0 0 1-5-3l-3-5a1.5 1.5 0 0 1 2.5-1.5L8 15'),
  mic2: P('M9 5a3 3 0 0 1 6 0v6a3 3 0 0 1-6 0zM5 11a7 7 0 0 0 14 0M12 18v4'),
  refresh2: P('M20 11a8 8 0 1 0-2.4 7.3M20 4v7h-7'), 
  chevD2: P('M6 9l6 6 6-6'), chevL2: P('M15 6l-6 6 6 6'), chevR2: P('M9 6l6 6-6 6'), 
  scissors: '<circle cx="6" cy="6" r="3"/><circle cx="6" cy="18" r="3"/>' + P('M20 4L8.5 15.5M8.5 8.5L20 20'),
  list: P('M8 6h13M8 12h13M8 18h13M4 6h.01M4 12h.01M4 18h.01'), listOrdered: P('M10 6h11M10 12h11M10 18h11M4 4h1v4M4 8h2M4 14h2l-2 3h2'),
  textCursor: P('M17 22h-1a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h1M7 22h1a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4H7'),
  messageSq: P('M4 4h16v12H9l-5 4z'), shieldCheck: P('M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6zM9 12l2 2 4-4'),
  loader: P('M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M5.6 18.4l2.8-2.8M15.6 8.4l2.8-2.8'),
  fileArchive: P('M14 2H5a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9zM14 2v7h7M10 11h4v4h-4zM12 15v3'),
  listChecks: P('M3 6l2 2 3-3M3 13l2 2 3-3M3 20l2 2 3-3M12 6h9M12 13h9M12 20h9'),
  circleDollar: '<circle cx="12" cy="12" r="9"/>' + P('M12 6v12M15 9a3 3 0 0 0-3-1.5c-1.7 0-3 .8-3 2s1.3 1.8 3 2.2 3 1 3 2.3-1.3 2-3 2a3 3 0 0 1-3-1.5'),
  grid2: P('M3 3h18v18H3zM3 9h18M3 15h18M9 3v18M15 3v18'),
  cornerDownLeft: P('M20 4v7a4 4 0 0 1-4 4H4M8 11l-4 4 4 4'),
  fillPlus: P('M4 20V4h16v16zM12 8v8M8 12h8'), fillMinus: P('M4 20V4h16v16zM8 12h8'),
  mapPin: P('M12 22s7-7 7-13a7 7 0 0 0-14 0c0 6 7 13 7 13z') + '<circle cx="12" cy="9" r="2.5"/>',
  freehand: P('M3 17c3-8 6-8 8-2s5 6 10-7'), 
  highlighter: P('M9 11l-6 6 4 4 6-6M9 11l6-6 4 4-6 6M15 5l2-2 4 4-2 2'),
  caseUpper: P('M3 16l4-10 4 10M4.5 12h5M13 16l4-10 4 10M14.5 12h5'),
  paintRoller: P('M3 5h14v5H3zM17 7h3v5h-8v3M12 15v6'),
  table: P('M3 4h18v16H3zM3 10h18M3 15h18M9 4v16M15 4v16'),
  spline: P('M4 20C4 10 14 14 20 4') + '<circle cx="4" cy="20" r="2"/><circle cx="20" cy="4" r="2"/>',
  lineStraight: P('M4 20L20 4'), lineArrow: P('M4 20L20 4M12 4h8v8'), lineArrows: P('M4 20L20 4M12 4h8v8M4 12v8h8'),
  lineCurve: P('M4 18c6 0 4-12 16-12'), lineElbow: P('M4 20V8h16'),
  pagesGrid: P('M3 3h8v8H3zM13 3h8v8h-8zM3 13h8v8H3zM13 13h8v8h-8z'),
  copyPages: P('M8 8h13v13H8zM16 5V3H3v13h2M12 12h5M12 16h5'),
  copyPlus: P('M8 8h14v14H8zM16 5V2H2v14h3M15 12v6M12 15h6'),
  clipboardPaste: P('M9 4h6v3H9zM6 6H5v15h14V6h-1M9 12h6M9 16h4'),
  
};
export const EDICON_NAMES = Object.keys(EDICONS);
